import dayjs from "dayjs";

import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

const ROSTER_URL = `${TENANT_API_URL}/roster`;

export const getTodayVisitsCount = async () => {
  try {
    const response = await axiosInstance.get(`${ROSTER_URL}/today-visits`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAllCheckInCheckOut = async () => {
  try {
    const response = await axiosInstance.get(`${ROSTER_URL}/logs`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const CheckInCheckOuts = async (startDate?: any, endDate?: any) => {
  try {
    const queryParams: Record<string, string> = {};

    if (startDate) {
      queryParams.startDate = dayjs(startDate).startOf("day").toISOString();
    }

    if (endDate) {
      queryParams.endDate = dayjs(endDate).endOf("day").toISOString();
    }

    const url = `${ROSTER_URL}/logs/date-range?${new URLSearchParams(queryParams).toString()}`;

    const response = await axiosInstance.get(url);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
export const getTodayCheckInCheckOutByCarer = async () => {
  try {
    const response = await axiosInstance.get(`${ROSTER_URL}/today-logs`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getLogsByVisitId = async (visitId: string) => {
  try {
    const response = await axiosInstance.get(`${ROSTER_URL}/logs/${visitId}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateLogById = async (
  logId: string,
  data: { checkIn?: Date; checkOut?: Date; note?: string }
) => {
  try {
    const response = await axiosInstance.put(
      `${ROSTER_URL}/logs/${logId}`,
      data
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

// csv API's

export const getDetailedStaffVisits = async (
  startDate: string,
  endDate: string,
  selectedUser?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${TENANT_API_URL}/roster/detailed-staff-visits`,
      {
        params: {
          startDate,
          endDate,
          selectedUser,
        },
      }
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getDetailedServiceVisits = async (
  startDate: string,
  endDate: string,
  selectedUser?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${TENANT_API_URL}/roster/detailed-service-visits`,
      {
        params: {
          startDate,
          endDate,
          selectedUser,
        },
      }
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTotalServiceHours = async (
  startDate: string,
  endDate: string,
  selectedUser?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${TENANT_API_URL}/roster/total-service-hours`,
      {
        params: {
          startDate,
          endDate,
          selectedUser,
        },
      }
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTotalStaffHours = async (
  startDate: string,
  endDate: string,
  selectedUser?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${TENANT_API_URL}/roster/total-staff-hours`,
      {
        params: {
          startDate,
          endDate,
          selectedUser,
        },
      }
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

// cancle visit API

export const cancelVisit = async (
  id: string,
  data: {
    payStaff: string[];
    chargeServiceUser: boolean;
    cancellationNote: string;
  }
) => {
  try {
    const response = await axiosInstance.put(
      `${TENANT_API_URL}/roster/cancel-visit/${id}`,
      data
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
